"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var styled_1 = __importStar(require("@seaweb/coral/hoc/styled"));
var childrenWithIndex_1 = __importDefault(require("@seaweb/coral/utils/childrenWithIndex"));
var TabsContext_1 = require("./TabsContext");
var TabPanelsContainer = styled_1.default.div.attrs({
    'data-coral-tab-panels-container': '',
})(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  overflow: hidden;\n  flex-grow: 1;\n"], ["\n  overflow: hidden;\n  flex-grow: 1;\n"])));
var TabPanelsContents = styled_1.default.div.attrs({
    'data-coral-tab-panels-contents': '',
})(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  display: flex;\n  align-items: stretch;\n\n  ", "\n\n  ", "\n"], ["\n  display: flex;\n  align-items: stretch;\n\n  ",
    "\n\n  ",
    "\n"])), function (_a) {
    var immediate = _a.immediate;
    return !immediate && styled_1.css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n      transition: all 0.4s ease;\n    "], ["\n      transition: all 0.4s ease;\n    "])));
}, function (_a) {
    var activeIndex = _a.activeIndex, cycle = _a.cycle;
    return styled_1.css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    transform: translateX(", "%);\n  "], ["\n    transform: translateX(", "%);\n  "])), -100 * (activeIndex + cycle));
});
var TabPanels = react_1.forwardRef(function TabPanels(_a, ref) {
    var as = _a.as, wrapper = _a.wrapper, wrapperRef = _a.wrapperRef, children = _a.children, _b = _a.immediate, immediate = _b === void 0 ? false : _b, _c = _a.unmount, unmount = _c === void 0 ? false : _c, props = __rest(_a, ["as", "wrapper", "wrapperRef", "children", "immediate", "unmount"]);
    var _d = TabsContext_1.useTabsContext(), activeIndex = _d.activeIndex, cycle = _d.cycle;
    return (react_1.default.createElement(TabsContext_1.TabPanelsContext.Provider, { value: { unmount: unmount } },
        react_1.default.createElement(TabPanelsContainer, __assign({ as: as, ref: ref }, props),
            react_1.default.createElement(TabPanelsContents, { as: wrapper, ref: wrapperRef, activeIndex: activeIndex, immediate: immediate, cycle: cycle }, childrenWithIndex_1.default(children)))));
});
exports.default = react_1.memo(TabPanels);
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;
